<template>
  <div
    v-show="activeTab === tabId"
    :aria-hidden="!activeTab !== tabId"
    :aria-labelledby="`tab-${tabId}`"
  >
    <slot />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'BaseTabContent',
  props: {
    activeTab: {
      type: String,
      required: true,
    },
    tabId: {
      type: String,
      required: true,
    },
  },
}
</script>
